export const MASK_3_2_4_NUMBER_PATTERN = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const MASK_3_3_4_NUMBER_PATTERN = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];



// WEBPACK FOOTER //
// ./src/views/components/Common/MaskUtils/MaskPatterns.js